module.exports = __webpack_public_path__ + "static/media/Talea.92ad9471.png";